module.exports = __webpack_public_path__ + "img/microsoft_admin_consent_required_screen.158aa3c6.png";